import React from "react";
import PropTypes from "prop-types";
import produce from "immer";
import Iframe from "react-iframe";
import CollectionLink from "../../utils/generate-collection-link";
import CollectionSpecialItem from "../../atoms/collection-special-item";
import styles from "./styles.m.css";
import { getStoryHeadline } from "../../utils/utils";

const CollectionsGrid = ({ collection, metadata, accentColor = "#FDDFF2" }) => {
  const { name, items, id } = collection;
  let stacks = items.filter(item => item.type === "collection").map((collection, index) => {
    collection = produce(collection, draft => {
      draft.items = draft.items.filter(({ story = {} }) => getStoryHeadline(story) != null && story.url != null);
    });
    return (
      <React.Fragment key={collection.id}>
        <CollectionSpecialItem collection={collection} />
      </React.Fragment>
    );
  });

  if (!stacks || !stacks.length) {
    return null;
  }

  return (
    <div className={`${styles["main-row"]} css${id}4P`}>
      <div className={`${styles["outer-sec"]}`}>
        <div
          className={`${styles["base"]} nine-stories-main container css${id}4P`}
          style={accentColor && { "--accent-color": accentColor }}
        >
          {name && (
            <CollectionLink collection={collection}>
              <h2 className={styles["main-title"]}>{name}</h2>
            </CollectionLink>
          )}
          <div className={styles["stack-grid"]}>{stacks}</div>
        </div>
        <div className={`${styles["base"]} container ${styles["iframe-form"]}`}>
          <Iframe
            url="https://view.genial.ly/5e7d7d1036d3a20e42b6bf42"
            width="100%"
            frameBorder="0"
            className={styles["ganail"]}
          />
        </div>
      </div>
    </div>
  );
};

const Collection = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.number,
  type: PropTypes.string,
  slug: PropTypes.string,
  readMoreText: PropTypes.string,
  items: PropTypes.shape()
});

CollectionsGrid.propTypes = {
  accentColor: PropTypes.string,
  collection: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    slug: PropTypes.string,
    items: PropTypes.arrayOf(Collection)
  }),
  metadata: PropTypes.shape({
    read_more_text: PropTypes.string
  })
};

export default CollectionsGrid;
